import React from 'react'

export default function Loanbtn({title}) {
   // console.log(props)
  return (
    <button className='btn-apply'> {title} </button>
  )
}
